// @module nowak.cloudflareRecaptchaExt.cloudflareRecaptchaExt
define('nowak.cloudflareRecaptchaExt.cloudflareRecaptchaExt.View'
,	[
	'nowak_cloudflarerecaptchaext_cloudflarerecaptchaext.tpl'
	
	,	'nowak.cloudflareRecaptchaExt.cloudflareRecaptchaExt.SS2Model'
	
	,	'Backbone'
    ]
, function (
	nowak_cloudflarerecaptchaext_cloudflarerecaptchaext_tpl
	
	,	cloudflareRecaptchaExtSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class nowak.cloudflareRecaptchaExt.cloudflareRecaptchaExt.View @extends Backbone.View
	return Backbone.View.extend({
		template: nowak_cloudflarerecaptchaext_cloudflarerecaptchaext_tpl
	,	initialize: function (options) {

		var self = this;

			// SEO fix: skip the Cloudflare Turnstile challenge during SEO prerender
			// (Prerender V2 / page generator). The external challenge script plus the
			// repeating timer in the callback below keep the page permanently "busy",
			// so the generator times out and marks pages "PossiblyIncomplete" (cached
			// blank for search engines). Real shoppers are unaffected.
			if (typeof SC !== 'undefined' && typeof SC.isPageGenerator === 'function' && SC.isPageGenerator()) {
				return;
			}

			$(document).ready(function () {
				// Render the Turnstile widget container
				var $target = $('#turnstile-container');
				if ($target.length) {
				// $target.html(turnstile_integration_tpl);
				// Load the Turnstile script dynamically
				$.getScript('https://challenges.cloudflare.com/turnstile/v0/api.js')
					.done(function () {
					// Initialize the Turnstile widget
						if (typeof turnstile !== 'undefined') {
							turnstile.render('#turnstile-container', {
								// 0x4AAAAAABeI_u9t6KwJE5HZ
							sitekey: '0x4AAAAAABfR5w8KBlDdniAf',
							// 0x4AAAAAABfR5w8KBlDdniAf
							// 0x4AAAAAABfR59QP_NphaRH3vTy3MR_8HMY
							callback: function (token) {
								// console.log(`Challenge Success ${token}`); // SEO fix: debug log disabled
								// SEO fix: was setInterval (an endless 1-second timer that also
								// prevented the prerendered page from ever settling); a one-shot
								// setTimeout is enough to fade the overlay out once.
								// setInterval(function() {
								setTimeout(function() {

								$('.turnstile-overlay').fadeOut('slow', function () {
									// $('.shopping-layout').fadeIn('slow');
									// self.reload();
								});

								}, 1000);

							}
							});
						} else {
							console.error('Turnstile is not defined after script load.');
						}
					})
					.fail(function (jqxhr, settings, exception) {
					console.error('Failed to load Turnstile script:', exception);
					});
				}
			});
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return nowak.cloudflareRecaptchaExt.cloudflareRecaptchaExt.View.Context
	,	getContext: function getContext()
		{
			//@class nowak.cloudflareRecaptchaExt.cloudflareRecaptchaExt.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
